<template>
  <div id="pluginModal">
    <!-- Add Block Modal -->
    <div class="o-modal">
      <div class="o-modal-content full">
        <div class="o-modal-header">
          <a
            @click="display.modal.pluginModal = false"
            class="close clickable"
          ><i class="far fa-times"></i></a>
          <p class="lead">{{ plugin.name }}</p>
        </div><!-- /.o-modal-header -->

        <iframe
          v-if="pluginUrl"
          :src="pluginUrl"
          frameborder="none"
          id="pluginIframe"
        />

      </div><!-- /.o-modal-content -->
    </div><!-- /.o-modal -->
  </div><!-- /#pluginModal -->
</template>

<script>
import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')

export default {
  data () {
    return {
      pluginUrl: ''
    }
  },
  computed: {
    ...mapState([
      'display',
      'plugin'
    ])
  },
  created () {
    this.assembleUrl()
  },
  methods: {
    assembleUrl () {
      let assembled = this.plugin.url
      if (this.plugin.arg1) {
        assembled = this.plugin.url + '/' + this.plugin.arg1
      }
      if (this.plugin.authRequired) {
        const userEmail = fb.auth.currentUser?.email
        assembled += `?email=${encodeURIComponent(userEmail)}`
      }
      this.pluginUrl = assembled
    }
    // assembleUrl () {
    //   console.log('Assemble URL')
    //   // Get login token
    //   fb.auth.onAuthStateChanged(user => {
    //     if (user) {
    //       user.getIdToken().then(token => {
    //         let assembled = this.plugin.url
    //         if (this.plugin.arg1) {
    //           assembled = this.plugin.url + '/' + this.plugin.arg1
    //         }
    //         this.pluginUrl = assembled
    //         // Wait and then send the token
    //         setTimeout(() => {
    //           if (this.plugin.authRequired) {
    //             this.sendToken(token)
    //           }
    //         }, 2000)
    //       })
    //     }
    //   })
    // },
    // sendToken (token) {
    //   console.log('Send Token')
    //   // Send the token to the iframe
    //   const iframeWindow = document.getElementById('pluginIframe').contentWindow
    //   iframeWindow.postMessage({ token: token }, this.pluginUrl)`
    // }
  }
}
</script>

<style scoped>
  #pluginModal iframe {
    width: 100%;
    height: calc(100% - 30px);
    margin-top: 30px;
  }
</style>
